import styled from 'styled-components';

import { appColors } from '../../config/colors';
import { device } from '../../config/sizes';

export const NavbarTopWrapper = styled.header`
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  width: 100%;
  padding: 1em;
  overflow: hidden;
  color: ${appColors.navbarFont};
  background-color: ${appColors.navbarBackground};
  border-bottom: 3px solid ${appColors.outline};

  @media ${device.tablet} {
    display: none;
  }
`;

export const NavbarTopTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const NavbarTopTitle = styled.div`
  font-weight: bold;
  text-decoration: none;
`;

export const NavbarTopArrow = styled.div`
  cursor: pointer;
  margin-left: auto;

  svg {
    vertical-align: middle;
  }
`;

export const NavbarTopElements = styled.nav`
  display: ${(props) => (props.hidden ? 'none' : '')};
  padding-top: 0.9em;

  a {
    display: block;
    overflow: hidden;
    padding-left: 0.8em;
    padding-bottom: 1em;
    text-decoration: none;
    font-size: 0.8em;
  }
`;

export const SideNavbarLeft = styled.aside`
  display: none;
  position: sticky;
  top: 10em;
  width: 300px;
  height: 100%;
  padding-right: 4em;
  padding-bottom: 1.5em;
  font-size: 0.8em;

  @media ${device.tablet} {
    display: block;
  }
`;

export const SideNavContainer = styled.nav`
  a {
    display: block;
    text-decoration: none;
    border-left: 3px solid;
    border-left-color: rgba(0, 0, 0, 0);
    color: ${appColors.fontSecondary};
    padding: 0.5em;

    &.highlighted {
      border-left: 3px solid ${appColors.outline};
      color: ${appColors.fontPrimary};
      font-weight: bold;
    }
  }
`;
